import { finish, error } from '../../../modules/betslip/actions/assign-referred-betslip';
import { finish as getReferredBetslip } from '../../../modules/betslip/actions/get-referred-betslip';

import api from '../../../api';

export function request(dispatch, { userId }) {
    api.post('/customers/' + userId + '/requested-betslip/assign', { force: false }).then( //temporary hardcoded
        ({ bets, expiresAt, assignee, when }) => {
            dispatch(getReferredBetslip({ id: userId, bets, expiresAt, assignee, when }));
            dispatch(finish(userId));
        },
        ({ errors }) => {
          dispatch(error(userId, errors))
        }
    );
}
